import { useState } from 'react';
import {
  DropDownContainer,
  DropDownHeader,
  DropDownList,
  DropDownListContainer,
  ListItem,
} from './styles';

interface SelectProps {
  options: Array<any>;
  icon: string;
  nameSelect: string;
  account: string;
  setAccount: (account: string) => void;
}

export function SelectAccount({
  options,
  icon,
  account,
  setAccount,
}: SelectProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggling = () => setIsOpen(!isOpen);

  function handleSelect(account: string) {
    setAccount(account);
    setIsOpen(!isOpen);
  }

  return (
    <DropDownContainer className="select">
      <DropDownHeader onClick={toggling}>
        <p>{account}</p>
        <img src={icon} alt="" />
      </DropDownHeader>
      {isOpen && (
        <DropDownListContainer>
          <DropDownList className="items">
            {options.map((option) => (
              <ListItem
                onClick={() => handleSelect(option)}
                key={Math.random()}
              >
                {option}
              </ListItem>
            ))}
          </DropDownList>
        </DropDownListContainer>
      )}
    </DropDownContainer>
  );
}
